import { ListFilter } from './filter.model';
import { SearchHighlights } from './search-highlight.model';

export interface GuideFilter extends ListFilter {}

export class GuideFilterModel {
    skip: number;
    take: number;
    paging: boolean;
    startDate?: string;
    endDate?: string;
    searchString?: string;

    constructor(private model: GuideFilter) {
        this.skip = model.skip || 0;
        this.take = model.take || 10;
        this.paging = model.paging || true;
        this.startDate = model.startDate || '';
        this.endDate = model.endDate || '';
        this.searchString = model.searchString || '';
    }
}

export interface Guide {
    attachmentId: number;
    attachmentUrl: string;
    id: string;
    isDownloadable: boolean;
    lastUpdateDate: string;
    tags: string[];
    title: string;
    /** Optional highlights returned from search API */
    highlights?: SearchHighlights;
    /** Array of matched search tokens */
    matchedTokens?: string[];
}

export class GuideModel {
    attachmentId: number;
    attachmentUrl: string;
    baseTags: string[];
    id: string;
    isDownloadable: boolean;
    lastUpdateDate: string;
    moreTags: string[];
    moreTagsShowed: boolean;
    tags: string[];
    title: string;
    /** Optional highlights returned from search API */
    highlights?: SearchHighlights;
    /** Array of matched search tokens */
    matchedTokens?: string[];

    constructor(private model: Guide) {
        (this.isDownloadable = model.isDownloadable), (this.attachmentId = model.attachmentId);
        this.attachmentUrl = model.attachmentUrl;
        this.baseTags = [];
        this.id = model.id;
        this.lastUpdateDate = model.lastUpdateDate;
        this.moreTags = [];
        this.moreTagsShowed = false;
        this.tags = model.tags;
        this.title = model.title;
        this.highlights = model.highlights;
        this.matchedTokens = model.matchedTokens;
    }
}
